

export default function ProfileTitle(){
    return(
      
      <h1 className="text-c32 text-black222 font-bold text-left 
      || mt-c48 mb-c32">Profile</h1>
    )
}